import { Navigate, Route, Routes } from "react-router-dom";
import { LANGS, ROUTES } from "@/i18n";
import { Layout } from "@/components/site/Layout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Philosophy from "@/pages/Philosophy";
import ClinicalCases from "@/pages/ClinicalCases";
import Publications from "@/pages/Publications";
import Interviews from "@/pages/Interviews";
import Contact from "@/pages/Contact";
import NotFound from "@/pages/NotFound";
import redirects from "@/data/redirects.json";

const PAGES = { home: Home, about: About, philosophy: Philosophy, cases: ClinicalCases, publications: Publications, interviews: Interviews, contact: Contact };
const routePath = (p) => p.replace(/\/$/, "") || "/";
const LEGACY = redirects;

export const AppRoutes = () => (
  <Routes>
    {LANGS.map((lang) => (
      <Route key={lang} element={<Layout lang={lang} />}>
        {Object.entries(PAGES).map(([key, Page]) => (
          <Route key={key} path={routePath(ROUTES[key][lang])} element={<Page />} />
        ))}
        <Route path={lang === "pl" ? "/pl/*" : "*"} element={<NotFound />} />
      </Route>
    ))}
    {Object.entries(LEGACY).map(([from, to]) => (
      <Route key={from} path={from} element={<Navigate to={to} replace />} />
    ))}
  </Routes>
);
